/**
 * @功能名称:给url添加全路径
 * @文件名称: formatPath.js
 * @Date: 2018/5/17 下午3:39.
 * @Author: zhangdanqing
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
export default function (path, host) {
  var reg = /^\//;
  var origin = host || location.origin;
  if (reg.test(path)) {
    return path.replace(reg, origin + '/');
  } else {
    return path;
  }
}
